export const DefaultPatientThreshold = {
  spo2_max_val: 100,
  spo2_min_val: 92,
  resp_max_val: 20,
  resp_min_val: 9,
  pr_max_val: 99,
  pr_min_val: 50,
  temp_max_val: 38.3,
  temp_min_val: 36.1,
  sys_max_val: 120,
  sys_min_val: 90,
  dia_max_val: 90,
  dia_min_val: 60,
}
